import React from 'react';
import { sRGBEncoding, Texture } from 'three';

export const Emissive = ({ texture }: { texture?: Texture }) => {
  if (!texture) return null;

  return <texture attach="emissiveMap" {...texture} encoding={sRGBEncoding} name="Updated_levar_emissive" />;
};
